import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EncryptDecryptService } from './encrypt-decrypt.service';

@Injectable()
export class EcdhInterceptor implements HttpInterceptor {

  constructor(private encryptDecryptService: EncryptDecryptService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.encryptDecryptService.ready).pipe(
      switchMap(() => {
        const deviceKey = this.encryptDecryptService.deviceKeyHex;
        if (!deviceKey) {
          return next.handle(request);
        }
        const cloned = request.clone({
          setHeaders: { 'Device-Key': deviceKey }
        });
        return next.handle(cloned);
      })
    );
  }
}
